import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as extend, r as insertBefore } from "../../language-D-vtM55V.js";
import { i as clikePunctuation } from "../../patterns-C0vJBvXO.js";
import "./json.js";
//#region src/prism/languages/jsonp.js
insertBefore(languages.jsonp = extend("json", { "punctuation": clikePunctuation }), "punctuation", { "function": /(?!\d)(?:(?!\s)[$\w\xa0-\uffff])+(?=\s*\()/ });
//#endregion

//# sourceMappingURL=jsonp.js.map